import { DataBean } from "../DataBean";

export class QuickturnAppointment extends DataBean {

    public async assignAppointment(idLn: number, idAttentionPoint: number, idAttentionTimeLapse: number, from: any, until: any, idAccount: number, idCustomerType: number, channelType: number, idCharacterization: number, idAgendaRequest: number, requestDate: any): Promise<any> {
        return this.getCustomService(
            "QuickTurnService",
            "com.quickturn.bean.Appointment_assignAppointment_Number_Number_Number_java.util.Date_java.util.Date_Number_Number_Number_Number_Number_java.util.Date",
            [idLn, idAttentionPoint, idAttentionTimeLapse, from, until, idAccount, idCustomerType, channelType, idCharacterization, idAgendaRequest, requestDate]);
    }

    public async getAppointmentByAccount(from: any, upto: any, idAccount: number, State: number): Promise<any> {
        return this.getCustomService(
            "QuickTurnService",
            "java.util.List_getAppointmentByAccount_java.util.Date_java.util.Date_Number_Number",
            [from, upto, idAccount, State]);
    }

    public async createAttentionTicketFromAppointment(idAppointment: number, date: any): Promise<any> {
        return this.getCustomService(
            "QuickTurnService",
            "com.quickturn.bean.AttentionTicket_createAttentionTicketFromAppointment_Number_java.util.Date",
            [idAppointment, date]);
    }

    public async cancelAppointment(idAppointment: number, appointmentDate: any, idAccountCanceled: number, obs: string): Promise<any> {
        return this.getCustomService(
            "QuickTurnService",
            "com.quickturn.bean.Appointment_cancelAppointment_Number_java.util.Date_Number_String",
            [idAppointment, appointmentDate, idAccountCanceled, obs]);
    }

}
